import LoadingImg from '../../../ui/LoadingImg';
import { IMAGE_BASE_URL } from '../../../../utils/env';
import { selectNewProduct } from '../../../../features/product/productSlice';
import { useSelector } from 'react-redux';
import NoImg from '../../../../assets/images/noImg.jpg'

interface ProdModImgPreviewProps {
    isLoadingImg: boolean;
    profilePreviewUrl: string;
    setIsLoadingImg: (value: boolean) => void;
}

export default function ProdModImgPreview({ isLoadingImg, profilePreviewUrl, setIsLoadingImg }: ProdModImgPreviewProps) {
    
    const newProductForm = useSelector(selectNewProduct);
    const imgSrc = profilePreviewUrl ? profilePreviewUrl
        : newProductForm.image ? `${IMAGE_BASE_URL}/${newProductForm.image}`
            : NoImg

    return (
        <div className='w-full flex flex-col space-y-2 justify-center items-center'>
            <div className='relative'>
                {isLoadingImg && (
                    <div className='h-[150px] absolute inset-0 flex items-center justify-center'>
                        <LoadingImg/>
                    </div>
                )}
                
                <img
                    src={imgSrc}
                    alt="Product preview"
                    onLoad={() => setIsLoadingImg(false)}
                    onError={(e) => {
                        setIsLoadingImg(false)
                        e.currentTarget.onerror = null; 
                        e.currentTarget.src = NoImg;
                    }}
                    className={`${isLoadingImg ? "opacity-0" : "opacity-100"} w-32 h-32 object-cover rounded border`}
                />
            </div>
        </div>
    )
}
